var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4979 1.99806V7.99806M21.4979 7.99806H15.4979M21.4979 7.99806L16.8679 3.63806C15.4885 2.2578 13.6979 1.36325 11.7659 1.0892C9.83386 0.815161 7.8651 1.17648 6.15628 2.1187C4.44746 3.06092 3.09117 4.53301 2.29179 6.31313C1.4924 8.09325 1.29323 10.085 1.72429 11.9881C2.15535 13.8913 3.19328 15.6028 4.68168 16.8647C6.17008 18.1267 8.02831 18.8707 9.97635 18.9846C11.9244 19.0986 13.8567 18.5764 15.4821 17.4966C17.1075 16.4168 18.3379 14.838 18.9879 12.9981",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateRight);
export default __webpack_public_path__ + "static/media/icon-Rotate-right.7949bb5989af16a7b6f4b84231038890.svg";
export { ForwardRef as ReactComponent };